// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/a06ba3ab/" + chunkId + "." + __webpack_require__.h() + ".va06ba3ab.js";
};